import React, { useState } from 'react';

/* ─── Shared mock data ───────────────────────────────────────── */
const ORDERS = [
  { id: 62648696, date: 'May 29, 5:18 PM', status: 'Awaiting Payment', statusClass: 'warn', email: 'v***@c***.org', total: '$1,240.00', items: 3, country: 'US' },
  { id: 62648512, date: 'May 29, 3:41 PM', status: 'Completed',        statusClass: 'ok',   email: 'a***@c***.org', total: '$865.00',   items: 1, country: 'GB' },
  { id: 62648201, date: 'May 29, 1:07 PM', status: 'Awaiting Fulfillment', statusClass: 'warn', email: 'r***@c***.org', total: '$540.00', items: 2, country: 'IN' },
  { id: 62647900, date: 'May 28, 4:55 PM', status: 'Completed',        statusClass: 'ok',   email: 'd***@c***.org', total: '$1,080.00', items: 4, country: 'KE' },
  { id: 62647412, date: 'May 28, 11:22 AM', status: 'Refunded',        statusClass: 'err',  email: 's***@c***.org', total: '$320.00',   items: 1, country: 'US' },
];

const BADGE: Record<string, { bg: string; color: string }> = {
  ok:   { bg: '#f0fdf4', color: '#16a34a' },
  warn: { bg: '#fffbeb', color: '#d97706' },
  err:  { bg: '#fef2f2', color: '#dc2626' },
};

/* ─── OPTION A: Card list (current list as cards) ────────────── */
function OrderListCards({ onOpen }: { onOpen: (id: number) => void }) {
  return (
    <div style={{ background: '#f8fafc', minHeight: 400 }}>
      {/* Search bar */}
      <div style={{ padding: '0.75rem', background: '#fff', borderBottom: '1px solid #e2e8f0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: '#f1f5f9', borderRadius: 10, padding: '0.5rem 0.75rem' }}>
          <span style={{ color: '#94a3b8', fontSize: '0.9rem' }}>🔍</span>
          <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Search order ID or email…</span>
        </div>
      </div>

      <div style={{ padding: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
        {ORDERS.map(o => {
          const b = BADGE[o.statusClass];
          return (
            <div key={o.id} onClick={() => onOpen(o.id)}
              style={{ background: '#fff', borderRadius: 12, padding: '1rem', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', cursor: 'pointer' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                <span style={{ fontWeight: 700, color: '#2563eb', fontSize: '0.9rem' }}>#{o.id}</span>
                <span style={{ fontWeight: 800, color: '#0f172a', fontSize: '0.95rem' }}>{o.total}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
                <span style={{ fontSize: '0.78rem', ...b, padding: '0.15rem 0.5rem', borderRadius: 999, fontWeight: 600 }}>{o.status}</span>
                <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{o.items} item{o.items>1?'s':''}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: '#94a3b8' }}>
                <span>{o.email}</span>
                <span>{o.date}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ─── OPTION B: Compact swipeable rows ───────────────────────── */
function OrderListRows({ onOpen }: { onOpen: (id: number) => void }) {
  return (
    <div style={{ background: '#f8fafc', minHeight: 400 }}>
      <div style={{ padding: '0.75rem', background: '#fff', borderBottom: '1px solid #e2e8f0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: '#f1f5f9', borderRadius: 10, padding: '0.5rem 0.75rem' }}>
          <span style={{ color: '#94a3b8', fontSize: '0.9rem' }}>🔍</span>
          <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Search…</span>
        </div>
      </div>
      <div style={{ background: '#fff' }}>
        {ORDERS.map((o, i) => {
          const b = BADGE[o.statusClass];
          return (
            <div key={o.id} onClick={() => onOpen(o.id)}
              style={{ padding: '0.875rem 1rem', borderBottom: i<ORDERS.length-1 ? '1px solid #f1f5f9' : 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              {/* Status dot */}
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: b.color, flexShrink: 0 }} />
              {/* Main info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.2rem' }}>
                  <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.875rem' }}>#{o.id}</span>
                  <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.875rem' }}>{o.total}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '0.75rem', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{o.email}</span>
                  <span style={{ fontSize: '0.72rem', color: '#94a3b8', flexShrink: 0, marginLeft: '0.5rem' }}>{o.date.split(',')[0]}</span>
                </div>
              </div>
              <span style={{ color: '#cbd5e1', fontSize: '0.8rem', flexShrink: 0 }}>›</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ─── Order Detail — OPTION A: Stacked sections ──────────────── */
function OrderDetailStacked({ onBack }: { onBack: () => void }) {
  return (
    <div style={{ background: '#f8fafc', minHeight: 400 }}>
      {/* Sticky header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0.75rem 1rem', display: 'flex', alignItems: 'center', gap: '0.75rem', position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '1.2rem', padding: 0 }}>←</button>
        <div style={{ flex: 1 }}>
          <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.9rem' }}>Order #62648696</span>
        </div>
        <span style={{ background: '#fffbeb', color: '#d97706', fontSize: '0.72rem', fontWeight: 600, padding: '0.2rem 0.5rem', borderRadius: 999, border: '1px solid #fde68a' }}>Awaiting Payment</span>
      </div>

      <div style={{ padding: '0.875rem' }}>
        {/* Total banner */}
        <div style={{ background: 'linear-gradient(135deg,#1a2332,#2d3f55)', borderRadius: 12, padding: '1rem 1.25rem', marginBottom: '0.875rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.6)', fontSize: '0.72rem' }}>Order Total</p>
            <p style={{ margin: 0, color: '#fff', fontWeight: 800, fontSize: '1.5rem' }}>$1,240.00</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.6)', fontSize: '0.72rem' }}>May 29, 5:18 PM</p>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.8)', fontSize: '0.78rem', marginTop: 2 }}>3 items · US</p>
          </div>
        </div>

        {/* Items */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', marginBottom: '0.75rem', overflow: 'hidden' }}>
          <p style={{ margin: 0, padding: '0.75rem 1rem', borderBottom: '1px solid #f1f5f9', fontWeight: 600, fontSize: '0.8rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Items</p>
          {[
            { name: 'CFA Program Level I', sku: 'CFA-L1', qty: 1, price: '$650.00' },
            { name: 'CFA Level I Registration', sku: 'CFA-L1-REG', qty: 1, price: '$390.00' },
            { name: 'Associate Membership', sku: 'AMBR', qty: 1, price: '$200.00' },
          ].map((p, i, arr) => (
            <div key={p.sku} style={{ padding: '0.75rem 1rem', borderBottom: i<arr.length-1 ? '1px solid #f9fafb' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ margin: 0, fontSize: '0.83rem', fontWeight: 600, color: '#0f172a' }}>{p.name}</p>
                <span style={{ fontFamily: 'monospace', fontSize: '0.72rem', color: '#94a3b8', background: '#f8fafc', padding: '0.05rem 0.3rem', borderRadius: 4 }}>{p.sku}</span>
              </div>
              <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.85rem', flexShrink: 0 }}>{p.price}</span>
            </div>
          ))}
        </div>

        {/* Customer + Payment in 2 cards */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.625rem', marginBottom: '0.75rem' }}>
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '0.875rem' }}>
            <p style={{ margin: '0 0 0.5rem', fontWeight: 600, fontSize: '0.72rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Customer</p>
            <p style={{ margin: '0 0 0.2rem', fontSize: '0.82rem', fontWeight: 600, color: '#0f172a' }}>V*** G***</p>
            <p style={{ margin: 0, fontSize: '0.75rem', color: '#64748b' }}>v***@c***.org</p>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '0.875rem' }}>
            <p style={{ margin: '0 0 0.5rem', fontWeight: 600, fontSize: '0.72rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Payment</p>
            <div style={{ display: 'inline-block', background: '#1a1f71', color: '#fff', fontSize: '0.65rem', fontWeight: 800, padding: '0.1rem 0.4rem', borderRadius: 4, marginBottom: 4, fontFamily: 'monospace' }}>VISA</div>
            <p style={{ margin: 0, fontSize: '0.75rem', color: '#64748b' }}>Awaiting</p>
          </div>
        </div>

        {/* Summary */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '0.875rem' }}>
          <p style={{ margin: '0 0 0.625rem', fontWeight: 600, fontSize: '0.72rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Summary</p>
          {[['Subtotal', '$1,240.00'], ['Shipping', '$0.00'], ['Tax', '$0.00']].map(([l, v]) => (
            <div key={l} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem', fontSize: '0.82rem', color: '#64748b' }}>
              <span>{l}</span><span>{v}</span>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '0.625rem', marginTop: '0.3rem', borderTop: '2px solid #f1f5f9', fontWeight: 800, fontSize: '1rem', color: '#0f172a' }}>
            <span>Total</span><span>$1,240.00</span>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Order Detail — OPTION B: Tab sections ──────────────────── */
function OrderDetailTabs({ onBack }: { onBack: () => void }) {
  const [tab, setTab] = useState<'items'|'customer'|'payment'>('items');
  return (
    <div style={{ background: '#f8fafc', minHeight: 400 }}>
      {/* Sticky header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ padding: '0.75rem 1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontSize: '1.2rem', padding: 0 }}>←</button>
          <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.9rem', flex: 1 }}>#62648696</span>
          <span style={{ background: '#fffbeb', color: '#d97706', fontSize: '0.72rem', fontWeight: 600, padding: '0.2rem 0.5rem', borderRadius: 999, border: '1px solid #fde68a' }}>Awaiting Payment</span>
        </div>
        {/* Total */}
        <div style={{ padding: '0.25rem 1rem 0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span style={{ fontSize: '1.75rem', fontWeight: 800, color: '#0f172a' }}>$1,240.00</span>
          <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>May 29 · 3 items · US</span>
        </div>
        {/* Tabs */}
        <div style={{ display: 'flex', borderTop: '1px solid #f1f5f9' }}>
          {(['items','customer','payment'] as const).map(t => (
            <button key={t} onClick={() => setTab(t)} style={{
              flex: 1, padding: '0.625rem 0', background: 'none', border: 'none', cursor: 'pointer',
              fontSize: '0.78rem', fontWeight: tab===t ? 700 : 500,
              color: tab===t ? '#2563eb' : '#94a3b8',
              borderBottom: tab===t ? '2px solid #2563eb' : '2px solid transparent',
              marginBottom: -1, textTransform: 'capitalize',
            }}>{t}</button>
          ))}
        </div>
      </div>

      <div style={{ padding: '0.875rem' }}>
        {tab === 'items' && (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
            {[
              { name: 'CFA Program Level I', sku: 'CFA-L1', price: '$650.00' },
              { name: 'CFA Level I Registration', sku: 'CFA-L1-REG', price: '$390.00' },
              { name: 'Associate Membership', sku: 'AMBR', price: '$200.00' },
            ].map((p, i, arr) => (
              <div key={p.sku} style={{ padding: '1rem', borderBottom: i<arr.length-1 ? '1px solid #f9fafb':'none', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <p style={{ margin: 0, fontWeight: 600, fontSize: '0.875rem', color: '#0f172a', marginBottom: 2 }}>{p.name}</p>
                  <span style={{ fontFamily: 'monospace', fontSize: '0.72rem', color: '#94a3b8', background: '#f8fafc', padding: '0.05rem 0.35rem', borderRadius: 4 }}>{p.sku}</span>
                </div>
                <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0f172a' }}>{p.price}</span>
              </div>
            ))}
            <div style={{ padding: '0.875rem 1rem', borderTop: '2px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: '1rem', color: '#0f172a' }}>
              <span>Total</span><span>$1,240.00</span>
            </div>
          </div>
        )}
        {tab === 'customer' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {[
              { label: 'Name', value: 'V*** G***' },
              { label: 'Email', value: 'v***@c***.org' },
              { label: 'Phone', value: '+1 ***-***-4567' },
              { label: 'Shipping', value: '123 M*** St, New York, US' },
            ].map(f => (
              <div key={f.label} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '0.875rem 1rem' }}>
                <p style={{ margin: '0 0 0.25rem', fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{f.label}</p>
                <p style={{ margin: 0, fontSize: '0.875rem', color: '#0f172a', fontWeight: 500 }}>{f.value}</p>
              </div>
            ))}
          </div>
        )}
        {tab === 'payment' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {[
              { label: 'Method', value: 'Visa — pending' },
              { label: 'Status', value: 'Awaiting Payment' },
              { label: 'Transaction', value: 'TXN-928374628' },
            ].map(f => (
              <div key={f.label} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '0.875rem 1rem' }}>
                <p style={{ margin: '0 0 0.25rem', fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{f.label}</p>
                <p style={{ margin: 0, fontSize: '0.875rem', color: '#0f172a', fontWeight: 500 }}>{f.value}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/* ─── Mockup shell (phone frame) ─────────────────────────────── */
function PhoneFrame({ title, rec, children }: { title: string; rec?: boolean; children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <h3 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#0f172a' }}>{title}</h3>
        {rec && <span style={{ background: '#2563eb', color: '#fff', fontSize: '0.65rem', padding: '0.1rem 0.45rem', borderRadius: 999, fontWeight: 700 }}>RECOMMENDED</span>}
      </div>
      <div style={{
        border: '2px solid #e2e8f0', borderRadius: 20, overflow: 'hidden',
        maxHeight: 520, overflowY: 'auto',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
      }}>
        {children}
      </div>
    </div>
  );
}

/* ─── Main page ──────────────────────────────────────────────── */
export function MobileOrdersMockup() {
  const [view, setView] = useState<'lists' | 'detail-a' | 'detail-b'>('lists');
  const [_openOrderId, setOpenOrderId] = useState<number | null>(null);
  const [_detailMode, setDetailMode] = useState<'A' | 'B'>('A');

  function openDetail(id: number, mode: 'A' | 'B') {
    setOpenOrderId(id);
    setDetailMode(mode);
    setView(mode === 'A' ? 'detail-a' : 'detail-b');
  }

  return (
    <div style={{ fontFamily: "'DM Sans','Segoe UI',system-ui,sans-serif", background: '#f1f5f9', minHeight: '100vh', padding: '2rem' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0f172a', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
          Mobile Orders — Mockups
        </h1>
        <p style={{ color: '#64748b', marginBottom: '2rem', fontSize: '0.9rem' }}>
          Tap order rows to preview the detail view. Use the ← back button to return.
        </p>

        {/* Toggle between list and detail views */}
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
          {[
            { label: 'Order Lists', v: 'lists' },
            { label: 'Detail — Stacked', v: 'detail-a' },
            { label: 'Detail — Tabs', v: 'detail-b' },
          ].map(opt => (
            <button key={opt.v} onClick={() => setView(opt.v as any)} style={{
              padding: '0.4rem 0.875rem', borderRadius: 8, border: '1px solid',
              borderColor: view === opt.v ? '#2563eb' : '#e2e8f0',
              background: view === opt.v ? '#eff6ff' : '#fff',
              color: view === opt.v ? '#2563eb' : '#64748b',
              fontWeight: view === opt.v ? 600 : 400,
              cursor: 'pointer', fontSize: '0.82rem',
            }}>{opt.label}</button>
          ))}
        </div>

        {view === 'lists' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '2rem' }}>
              <PhoneFrame title="Option A — Order Cards" rec>
                <OrderListCards onOpen={(id) => openDetail(id, 'A')} />
              </PhoneFrame>
              <PhoneFrame title="Option B — Compact Rows">
                <OrderListRows onOpen={(id) => openDetail(id, 'B')} />
              </PhoneFrame>
            </div>

            {/* Comparison */}
            <div style={{ marginTop: '1.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              {[
                { title: 'Option A — Cards', pros: ['All key info visible', 'Easy to scan total + status', 'No horizontal scrolling'], cons: ['Fewer orders visible', 'More scrolling needed'], rec: true },
                { title: 'Option B — Rows', pros: ['Dense — more orders on screen', 'Fast to skim IDs', 'Native iOS/Android feel'], cons: ['Less info per row', 'Total hidden until drill-in'], rec: false },
              ].map(o => (
                <div key={o.title} style={{ background: '#fff', borderRadius: 12, padding: '1rem', border: o.rec ? '2px solid #2563eb' : '1px solid #e2e8f0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
                    <span style={{ fontWeight: 700, fontSize: '0.85rem' }}>{o.title}</span>
                    {o.rec && <span style={{ background: '#2563eb', color: '#fff', fontSize: '0.6rem', padding: '0.1rem 0.4rem', borderRadius: 999, fontWeight: 700 }}>RECOMMENDED</span>}
                  </div>
                  {o.pros.map(p => <p key={p} style={{ margin: '0 0 0.2rem', fontSize: '0.78rem', color: '#16a34a' }}>✓ {p}</p>)}
                  {o.cons.map(c => <p key={c} style={{ margin: '0 0 0.2rem', fontSize: '0.78rem', color: '#94a3b8' }}>✗ {c}</p>)}
                </div>
              ))}
            </div>
          </>
        )}

        {view === 'detail-a' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '2rem' }}>
              <PhoneFrame title="Detail A — Stacked Sections" rec>
                <OrderDetailStacked onBack={() => setView('lists')} />
              </PhoneFrame>
            </div>
            <div style={{ marginTop: '1rem', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, padding: '0.875rem', fontSize: '0.82rem', color: '#1d4ed8' }}>
              <strong>Stacked sections</strong>: All info visible at once — scroll down to see customer + payment. Best for one-handed use. The dark total banner gives instant visual hierarchy.
            </div>
          </>
        )}

        {view === 'detail-b' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '2rem' }}>
              <PhoneFrame title="Detail B — Tabbed Sections">
                <OrderDetailTabs onBack={() => setView('lists')} />
              </PhoneFrame>
            </div>
            <div style={{ marginTop: '1rem', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '0.875rem', fontSize: '0.82rem', color: '#475569' }}>
              <strong>Tabbed sections</strong>: Cleaner per-section focus — tap Items / Customer / Payment. Less scrolling within sections but requires more taps to see full order context.
            </div>
          </>
        )}
      </div>
    </div>
  );
}
